import React from 'react';
import { useSelector } from "react-redux";
import useFetch from "hooks/useFetch";
import useGaPageView from "hooks/useGaPageView";
import FoodCourtLayout from 'components/Layout/FoodCourtLayout';
import languages from "languages/languages";
import FoodCourtList from 'components/FoodCourt/FoodCourtList';
import FilterSection from "components/shared/FilterSection";
import FoodCourtCategories from 'components/FoodCourt/FoodCourtCategories';
import FoodCourtTitle from "components/FoodCourt/FoodCourtTitle"
import styles from './Home.module.css';
import MapRouterMaster from 'containers/MapRouterMaster';
import { mapRouterType, gaSettings } from 'config/constants';
import { mainApiPath } from "api/constants";

function FoodCourtHome() {
    const langState = useSelector((state) => state.language.lang);
    const [error, loading, data] = useFetch(mainApiPath.foodcourt_store);
    
    const favouriteTitle = languages[langState]["Được yêu thích"];
    const shouldTryTitle = languages[langState]["Nên thử"];

    const gaTitle = gaSettings.foodcourt.title;
    const gaLocation = gaSettings.foodcourt.location;
    useGaPageView({gaTitle, gaLocation});
    
    return (
        <FoodCourtLayout 
            error={error}
            loading={loading}
            left= {
                <>
                    <FoodCourtTitle loading={loading} />
                    <div className={styles.foodCourtHomeMap}>
                        <MapRouterMaster type={mapRouterType.pathGuide} slotInfo={{floorLevel: 3, svgId: 19}} rotate={0} hideTravelBar layout={'foodcourt_home'}/>
                    </div>    
                    <div className={styles.line}></div>
                    <FilterSection search loading={loading} />
                </>
            }
            right ={
                <>
                    <div className={styles.foodcourt_layout_categories}>
                        <FoodCourtCategories  categories={ data ? data.favourite : null } loading={loading} titleCategories={favouriteTitle}/>
                        <FoodCourtCategories  categories={ data ? data.should_try : null } loading={loading} titleCategories={shouldTryTitle}/>    
                    </div>
                    <div className={styles.foodcourt_layout_list}>
                        <FoodCourtList list={ data ? data.list : null} loading={loading} />
                    </div>
                </>   
                
            }

        />
    );    
}
export default FoodCourtHome;